import { render, staticRenderFns } from "./CmgNutritionCalculatorIngredientsBanner.vue?vue&type=template&id=7815aeb2&scoped=true&lang=pug"
import script from "./cmg-nutrition-calculator-ingredients-banner.ts?vue&type=script&lang=ts&external"
export * from "./cmg-nutrition-calculator-ingredients-banner.ts?vue&type=script&lang=ts&external"
import style0 from "./CmgNutritionCalculatorIngredientsBanner.vue?vue&type=style&index=0&id=7815aeb2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7815aeb2",
  null
  
)

export default component.exports